import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1c205740"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c205740')) {
      api.createRecord('1c205740', component.options)
    } else {
      api.reload('1c205740', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1c205740", function () {
      api.rerender('1c205740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customer_dashboard/tax_return/Index.vue"
export default component.exports